import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { withPageTracking } from "../../../services/postHog";

const QuizCreateFromExisting = () => {
  const [searchParams] = useSearchParams();
  const classId = searchParams.get("classId");
  console.log(classId);

  return (
    <FruitifyContainer>
      <Typography variant="h3" fontWeight="bold">
        Choose quiz
      </Typography>
    </FruitifyContainer>
  );
};

export default withPageTracking(QuizCreateFromExisting, {
  feature: "quiz-create-from-existing",
});
